import { FilterValue } from "../Filters/FilterValue";
import { SwayyStatusTone } from "../SwayyOrder/SwayyOrderFilters";

export const SWAYY_INVOICE_STATUS_OPTIONS: FilterValue[] = [
  { id: "pending", value: "Pending" },
  { id: "generated", value: "Generated" },
  { id: "failed", value: "Failed" },
  { id: "void", value: "Void" },
];

export const SWAYY_CREDIT_NOTE_REASON_OPTIONS: FilterValue[] = [
  { id: "refund", value: "Refund" },
  { id: "rto", value: "RTO" },
  { id: "return", value: "Return" },
  { id: "price_adjustment", value: "Price Adjustment" },
  { id: "goodwill", value: "Goodwill" },
  { id: "billing_error", value: "Billing Error" },
];

export const getSwayyInvoiceStatusLabel = (status: string): string =>
  SWAYY_INVOICE_STATUS_OPTIONS.find((option) => option.id === status)?.value ??
  status.replace(/_/g, " ");

export const getSwayyCreditNoteReasonLabel = (reason: string): string =>
  SWAYY_CREDIT_NOTE_REASON_OPTIONS.find((option) => option.id === reason)
    ?.value ?? reason.replace(/_/g, " ");

export const getSwayyInvoiceStatusTone = (status: string): SwayyStatusTone => {
  const value = (status || "").toLowerCase();
  if (value === "generated") return "success";
  if (value === "pending") return "pine";
  if (value === "failed") return "danger";
  if (value === "void") return "muted";
  return "muted";
};
